import React from "react";
import "./Testimonials.css";

const Testimonials = () => {
  return (
    <section className="bg-light py-5">

      <div className="container">

        <h2 className="text-center fw-bold mb-5">
          Patient Testimonials
        </h2>

        <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">

          <div className="carousel-inner">

            {/* Slide 1 */}
            <div className="carousel-item active">

              <div className="row justify-content-center">

                <div className="col-md-4">
                  <div className="card border-0 shadow-sm p-4 text-center">
                    <h5>⭐⭐⭐⭐⭐</h5>
                    <p className="text-muted">
                      Dr Abhinav Singh provided excellent treatment for my kidney stone problem.
                    </p>
                    <h6 className="fw-bold">Rajesh Sharma</h6>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="card border-0 shadow-sm p-4 text-center">
                    <h5>⭐⭐⭐⭐⭐</h5>
                    <p className="text-muted">
                      Very professional doctor. My prostate issue was treated successfully.
                    </p>
                    <h6 className="fw-bold">Amit Verma</h6>
                  </div>
                </div>

              </div>

            </div>

            {/* Slide 2 */}
            <div className="carousel-item">

              <div className="row justify-content-center">

                <div className="col-md-4">
                  <div className="card border-0 shadow-sm p-4 text-center">
                    <h5>⭐⭐⭐⭐⭐</h5>
                    <p className="text-muted">
                      Best consultation experience for urinary infection treatment.
                    </p>
                    <h6 className="fw-bold">Sunita Patel</h6>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="card border-0 shadow-sm p-4 text-center">
                    <h5>⭐⭐⭐⭐</h5>
                    <p className="text-muted">
                      Excellent guidance and friendly behaviour from doctor.
                    </p>
                    <h6 className="fw-bold">Kundan Chandela</h6>
                  </div>
                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default Testimonials;